<template>
	<div>
		<div :class="columnsClass(columns)">
			<card
				:titleLabel=titleLabel
				:subtitleLabel=subtitleLabel
				:imageLogo=imageLogo
        :urlYoutube=urlYoutube
				:urlDoc=urlDoc
				:numberPhotos=numberPhotos
				:labelImageToShow=labelImageToShow>
			</card>
		</div>
	</div>
</template>

<script>
import Card from "@/components/card/Card.vue";

export default {
  components: {
    Card
  },

  props: [
    "columns",
    "titleLabel",
    "subtitleLabel",
    "imageLogo",
    "urlYoutube",
    "urlDoc",
    "numberPhotos",
    "labelImageToShow"
  ],

  methods: {
    columnsClass: function(columns) {
      return `product_grid column_${columns}`;
    }
  }
};
</script>

<style>
h1.title {
  font-size: 1.5em !important;
}

.product_grid {
  float: left;
  display: block;
}

.column_1 {
  position: relative;
}

.product_details {
  position: absolute;
  bottom: 0;
  overflow: hidden;
  width: 0;
  height: 0;
  color: #fff;
  transition: all 0.9s linear;
  opacity: 0;
}

.column_6:hover .product_details,
.column_5:hover .product_details,
.column_4:hover .product_details,
.column_3:hover .product_details,
.column_2:hover .product_details,
.column_1:hover .product_details {
  right: 0;
  width: 100%;
  height: 100%;
  padding: 1em;
  opacity: 1;
}

.product_details .title,
.product_details .price {
  font-weight: 300;
}

.column_2 {
  position: relative;
  float: left;
  width: 50%;
  margin-top: 50px;
}

.column_3 {
  position: relative;
  float: left;
  width: 33.3333333%;
}

.column_4 {
  position: relative;
  float: left;
  width: 25%;
}

.column_5 {
  position: relative;
  float: left;
  width: 20%;
}

.column_6 {
  position: relative;
  float: left;
  width: 16.66666666667%;
}

.product_img {
  height: 320px;
  background-size: cover;
}

@media (max-width: 900px) {
  .column_6 {
    width: 20%;
  }
  .product_img {
    width: 80%;
  }
}

@media (max-width: 768px) {
  .column_6,
  .column_5 {
    width: 25%;
  }
  .product_desc {
    display: none;
  }
}

@media (max-width: 600px) {
  .column_6,
  .column_5,
  .column_4 {
    width: 33.3333333333%;
  }
  .product_details {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    padding: 1em;
    opacity: 1;
  }
  @media (max-width: 500px) {
    .column_6,
    .column_5,
    .column_4,
    .column_3,
    .column_2 {
      width: 100%;
    }
  }
}
</style>
